// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel-list-layout_wrapper___zkvq","show-more-content":"carousel-list-layout_show-more-content__PLgOM"};